import Vue from "vue"

// Google Analytics - kept in localStorage 
export const CONSENT_STORAGE_KEY = "fia-cookie-consent";
export const CONSENT_VERSION = 1;

export const consentState = Vue.observable({
    consent: readConsent(),
    settingsOpen: false
});

function readConsent() {
    try {
        const saved = JSON.parse(localStorage.getItem(CONSENT_STORAGE_KEY));
        if (saved && saved.version === CONSENT_VERSION && typeof saved.analytics === "boolean") {
            return saved;
        }
    } catch (e) {
    }
    return null;
}

function updateGtagConsent(analytics) {
    if (typeof window.gtag === "function") {
        window.gtag("consent", "update", {
            analytics_storage: analytics ? "granted" : "denied"
        });
    }
}

function deleteAnalyticsCookies() {
    const names = document.cookie.split(";")
        .map(c => c.split("=")[0].trim())
        .filter(n => n === "_ga" || n.indexOf("_ga_") === 0 || n === "_gid" || n === "_gat");

    const parts = window.location.hostname.split(".");
    const domains = [""];
    for (let i = 0; i < parts.length - 1; i++) {
        domains.push("; domain=." + parts.slice(i).join("."));
    }

    names.forEach(name => {
        domains.forEach(domain => {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
        });
    });
}

export function saveConsent(analytics) {
    const consent = { version: CONSENT_VERSION, analytics: analytics, date: new Date().toISOString() };

    try {
        localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {
    }

    updateGtagConsent(analytics);
    if (!analytics) {
        deleteAnalyticsCookies();
    }

    consentState.consent = consent;
    consentState.settingsOpen = false;
}

export function openCookieSettings() {
    consentState.settingsOpen = true;
}

export function closeCookieSettings() {
    consentState.settingsOpen = false;
}
